<div class="player-container" [ngClass]="{ 'no-spacing': noSpacing === false }">
  <div class="player-wrapper">
    <div #player class="player"></div>
  </div>
</div>
